import React from "react";
import { Col, Row } from "react-bootstrap";
import prefixes from "../data/prefixes";

const Rosheta = ({ rosheta, physician }) => {
  return (
    <div>
      <div className="px-3">
        {rosheta.map((m, index = 0) => (
          <Row
            key={index + 1}
            className="align-items-center mb-2 py-2 px-2 border rounded bg-light"
            style={{ fontSize: "0.95rem", color: "#070707ff" }}
          >
            <Col xs={12} lg={6} className="fw-semibold">
              {m.tradeLabel || <span className="text-muted">No name yet</span>}
            </Col>
            <Col xs={12} lg={4}>
              {m.direction || (
                <span className="text-muted">No direction typed</span>
              )}
            </Col>
          </Row>
        ))}
      </div>
    </div>
  );
};

export default Rosheta;
